import { render, staticRenderFns } from "./ApplicationRead.vue?vue&type=template&id=b1e55f0a&scoped=true&"
import script from "./ApplicationRead.vue?vue&type=script&lang=js&"
export * from "./ApplicationRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e55f0a",
  null
  
)

export default component.exports